"use strict";
exports.__esModule = true;
var common_helper_1 = require("../helpers/common.helper");
function spendMoreTemplate(qualifiedThreshold, nextThreshold, cart) {
    var html = '';
    var freeGiftsIds = common_helper_1.getCartFreeGiftIds(cart);
    var cartTotal = common_helper_1.getCartTotal(cart);
    if (freeGiftsIds.length === 0) {
        return getHtml(qualifiedThreshold, 'You qualify for a free gift');
    }
    var currentFreeGiftThresholdValue = getCartFreeGiftThresholdValue(cart);
    if (currentFreeGiftThresholdValue < qualifiedThreshold.value) {
        return getHtml(qualifiedThreshold, 'You qualify for a better gift');
    }
    if (!nextThreshold) {
        return html;
    }
    var item = nextThreshold.giftWithPurchase;
    var nextThresholdVal = nextThreshold.value;
    var spendMoreVal = nextThresholdVal - cartTotal;
    var spendMoreTextValHtml = '';
    var descriptionHtml = "<div class=\"spend-more-description\">" + item.productBodyHtml + "</div>";
    var spendMoreLinkHtml = "<a class=\"spend-more-link\" href=\"/\">Shop More</a>";
    if (spendMoreVal < 0) {
        spendMoreTextValHtml = "<span class=\"spend-more-item-text-val\">You qualify for a free gift</span>";
        spendMoreLinkHtml = "<a class=\"spend-more-link js-open-free-gift-popup\" href=\"/\">Click here</a>";
    }
    else {
        spendMoreTextValHtml = "<span class=\"spend-more-item-text-val\">Spend \u00A3" + spendMoreVal + " more to unlock a gift</span>";
    }
    html += "<div class=\"spend-more-item\">\n                  <img class=\"spend-more-item-img\" src=\"" + item.productImageSrc + "\" alt=\"" + item.productTitle + "\">\n                  <div class=\"spend-more-item-text\">\n                    " + spendMoreTextValHtml + "\n                    <p class=\"spend-more-item-title\"> " + item.productTitle + "</p>\n                    " + descriptionHtml + "\n                    " + spendMoreLinkHtml + "\n                  </div>\n                  \n              </div>";
    return html;
}
exports["default"] = spendMoreTemplate;
function getHtml(qualifiedThreshold, msg) {
    var titleHtml = '';
    var descriptionHtml = '';
    var imageHtml = '';
    var spendMoreTextValHtml = "<span class=\"spend-more-item-text-val\">" + msg + "</span>";
    var spendMoreLinkHtml = "<a class=\"spend-more-link js-open-free-gift-popup\" href=\"/\">Click here</a>";
    if (!qualifiedThreshold) {
        return '';
    }
    var item = qualifiedThreshold.giftWithPurchase;
    if (item) {
        titleHtml = "<div class=\"spend-more-description\">" + item.productTitle + "</div>";
        descriptionHtml = "<div class=\"spend-more-description\">" + item.productBodyHtml + "</div>";
        imageHtml = "<img class=\"spend-more-item-img\" src=\"" + item.productImageSrc + "\" alt=\"" + item.productTitle + "\">";
        return "<div class=\"spend-more-item\">\n                  " + imageHtml + "\n                  <div class=\"spend-more-item-text\">\n                    " + spendMoreTextValHtml + "\n                    " + titleHtml + "\n                    " + descriptionHtml + "\n                    " + spendMoreLinkHtml + "\n                  </div>\n              </div>";
    }
    else {
        return spendMoreTextValHtml + "<br>" + spendMoreLinkHtml;
    }
}
function getCartFreeGiftThresholdValue(cart) {
    for (var _i = 0, _a = cart.items; _i < _a.length; _i++) {
        var cartItem = _a[_i];
        if (cartItem.product_type === 'Sample' || cartItem.product_type === 'GWP') {
            var itemThreshold = cartItem.properties._threshold;
            if (!itemThreshold) {
                return 0;
            }
            return itemThreshold.value;
        }
    }
}
